

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface SalesManParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface SalesMan {
    id?: string;
    name: string;
    tenantId?: string;
    brandId?: string;
    parameters?: SalesManParameter[];
    links?: any;
}

export abstract class SalesManData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<SalesMan[]>;
  abstract create(url: string,data: SalesMan): Observable<any>;
  abstract update(url: string,data: SalesMan): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
